import React from 'react';

interface TabIconProps {
  active: boolean;
}

const RisksIcon: React.FC<TabIconProps> = ({ active }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5216 2.49884L19.4602 16.2489C19.6904 16.6474 19.5538 17.1571 19.1552 17.3872C19.0286 17.4604 18.8848 17.4989 18.7386 17.4989H2.86141C2.40118 17.4989 2.02808 17.1258 2.02808 16.6655C2.02808 16.5192 2.06658 16.3755 2.13973 16.2489L10.0783 2.49884C10.3084 2.10026 10.8181 1.9637 11.2166 2.19382C11.3433 2.26696 11.4486 2.37216 11.5216 2.49884ZM4.30478 15.8322H17.2951L10.8 4.58217L4.30478 15.8322ZM9.96663 13.3322H11.6333V14.9989H9.96663V13.3322ZM9.96663 7.49884H11.6333V11.6655H9.96663V7.49884Z"
      fill={active ? '#4E3178' : '#738290'}
    />
  </svg>
);

export default RisksIcon;
